import React from 'react';
import _ from 'lodash';
import { subscribe, publish, JUTRO_TOPICS } from '@jutro/events';
import { MLTagManagerService } from 'ml-portals-services-react';


import GoogleAnalytics from './GoogleAnalytics';
import SegmentIO from './SegmentIO';

import qbConfig from './config/Events-QB.json'
import peConfig from './config/Events-PE.json'
import ceConfig from './config/Events-CE.json'

const fnolMethods = [
    'createClaim',
    'submitClaim'
];
const quoteAndBindMethods = [
    'create',
    'retrieve',
    'saveAndQuote',
    'bind'
];
const transformers = [
    {
        source: "tracking_serverCall",
        target: "journey_payment",
        transformer: (target, payload) => {
            if (payload
                && payload.path === 'billing/directBillPayment'
                && payload.method === 'makeDirectBillPayment') {
                const paymentData = payload.params[0];
                publish(target, {
                    invoiceIds: paymentData.invoiceIds,
                    amountPaid: paymentData.amountPaid,
                    paymentMethod: paymentData.paymentInstrument.paymentMethod
                });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_claimNote",
        transformer: (target, payload) => {
            if (payload && payload.method === 'createClaimNote') {
                const response = payload.response;
                publish(target, {
                    method: 'createClaimNote',
                    action: 'create',
                    claimNumber: payload.params[0],
                    subject: payload.params[1].subject,
                    body: payload.params[1].body,
                    author: response.author,
                    publicId: response.publicID
                });
            } 
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_account",
        transformer: (target, payload) => {
            if (payload && payload.method === 'addEnrollmentRecord') {
                publish(target, {
                    accountNumber: payload.params[0].accountNumber,
                    policyNumber: payload.params[0].details.policyNumber,
                    method: payload.method,
                    path: payload.path
                });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_fnol",
        transformer: (target, payload) => {
            if (payload && payload.method && fnolMethods.includes(payload.method)) {
                const response = payload.response;
                const policy = response.policy;
                publish(target, {
                    method: payload.method,
                    path: payload.path,
                    accountNumber: policy.accountNumber,
                    policyNumber: policy.policyNumber,
                    policyType: policy.policyType,
                    claimNumber: response.claimNumber,
                    lossCause: response.lossCause,
                    lossDate: response.lossDate,
                    lossType: response.lossType
                });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_policyChange",
        transformer: (target, payload) => {
            if (payload
                && payload.path
                && payload.method === 'bind'
                && payload.path === 'policychange/policychange') {
                const policyChange = payload.response.policyChange;
                if (policyChange.status === 'Bound') {
                    publish(target, {
                        accountNumber: policyChange.accountNumber,
                        policyNumber: policyChange.policyNumber,
                        productCode: policyChange.productCode,
                        effectiveDate: policyChange.effectiveDate,
                        jobID: policyChange.jobID,
                        history: policyChange.history
                    });
                }
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_submission",
        transformer: (target, payload) => {
            if (payload
                && (payload.path === 'quote/quote')
                && quoteAndBindMethods.includes(payload.method)) {
                const response = payload.response;
                const baseData = response.baseData;
                const newPayload = {
                    method: payload.method,
                    accountNumber: baseData.accountNumber,
                    quoteID: response.quoteID,
                    productCode: baseData.productCode

                };
                if (payload.method === 'bind') {
                    publish(target, Object.assign(newPayload, {policyNumber: response.bindData.policyNumber}));
                } else {
                    publish(target,newPayload);
                }
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "tracking_journey",
        transformer: (target, payload) => {
            if (payload.path === 'quote/quote') {
                if (payload.method === 'create') {
                    const response = payload.response;
                    const baseData = payload.response.baseData;
                    publish(target,{
                        eventName: 'Submission Created',
                        accountNumber: baseData.accountNumber,
                        jobID: response.quoteID,
                        productCode: baseData.productCode,
                        accountHolder: {
                            name: baseData.accountHolder.displayName,
                            address: baseData.accountHolder.primaryAddress.displayName,
                            email: baseData.accountHolder.emailAddress1
                        }
                    });
                } else if (payload.method === 'retrieve') {
                    const response = payload.response;
                    const baseData = payload.response.baseData;
                    publish(target,{
                        eventName: 'Submission Retrieved',
                        accountNumber: baseData.accountNumber,
                        jobID: response.quoteID,
                        productCode: baseData.productCode
                    });
                } else if (payload.method === 'saveAndQuote') {
                    const response = payload.response;
                    const baseData = response.baseData;
                    const quoteData = response.quoteData;
                    quoteData.offeredQuotes.forEach(q => {
                        if (q.isCustom) {
                            publish(target,{
                                eventName: 'Quote Showed',
                                accountNumber: baseData.accountNumber,
                                jobID: response.quoteID,
                                productCode: baseData.productCode,
                                branchCode: q.branchCode,
                                value: q.total
                            });
                        }
                    });
                } else if (payload.method === 'bind') {
                    const response = payload.response;
                    const baseData = response.baseData;
                    const bindData = response.bindData;
                    publish(target,{
                        eventName: 'Policy Bound',
                        accountNumber: baseData.accountNumber,
                        policyNumber: bindData.policyNumber,
                        jobID: response.quoteID,
                        paymentPlan: bindData.paymentPlans[0].name
                    });
                }
            } else if (payload.path === 'customquote' && payload.method === 'updateCustomQuote') {
                const response = payload.response;
                publish(target,{
                    eventName: 'Quote Showed',
                    jobID: response.quoteID,
                    branchCode: response.branchCode,
                    value: response.total
                });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "tracking_journey",
        transformer: (target, payload) => {
            if (payload.path === 'policychange/policychange' && payload.method === 'bind') {
                const jsonResponse = payload.response;
                const change = jsonResponse.policyChange;
                const baseEvent = {
                    eventName: 'Policy Changed',
                    accountNumber: change.accountNumber,
                    jobID: change.jobID,
                    policyNumber: change.policyNumber,
                    productCode: change.productCode,
                    transactionCost: change.transactionCost,
                    totalCost: change.totalCost,
                    previousTotalCost: change.previousTotalCost,
                    effectiveDate: change.effectiveDate
                };
                publish(target,baseEvent);
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "tracking_journey",
        transformer: (target, payload) => {
            if (payload.path === 'policychange/policychange' && payload.method === 'bind') {
                const jsonResponse = payload.response;
                const change = jsonResponse.policyChange;

                change.history
                    .filter((h) => h.entityType === 'mortgagee')
                    .forEach((h) => {
                        publish(target,{
                            eventName: `Policy Changed - Mortgagee ${h.action}`,
                            accountNumber: change.accountNumber,
                            policyNumber: change.policyNumber,
                            productCode: change.productCode,
                            mortgagee: h.action !== 'removed' ? {
                                name: h.entity.policyAdditionalInterest.displayName,
                                effectiveDate: h.effectiveDate,
                                address: h.entity.policyAdditionalInterest.primaryAddress.displayName
                            } : h.itemName
                        });
                    });

                change.history
                    .filter((h) => h.entityType === 'scheduledProperty')
                    .forEach((h) => {
                        publish(target,{
                            eventName: `Policy Changed - Valuable ${h.action}`,
                            accountNumber: change.accountNumber,
                            policyNumber: change.policyNumber,
                            productCode: change.productCode,
                            mortgagee: h.action !== 'removed' ? {
                                type: h.entity.type,
                                description: h.entity.description
                            } : h.itemName
                        });
                    });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "journey_account",
        transformer: (target, payload) => {
            if (payload && payload.method === 'updateAccountContactSummary') {
                publish(target,{
                    accountNumber: payload.params[0].accountNumber,
                    method: payload.method,
                    path: payload.path
                });
            }
        }
    },
    {
        source: "tracking_serverCall",
        target: "tracking_identify",
        transformer: (target, payload) => {
            if (payload.path === 'enrollment/status' && payload.method === 'getEnrolledStatus') {
                if (payload.response.enrolled) {
                    publish(target,{userId: payload.response.username});
                }
            } else if (payload.path === 'profileinfo/user' && payload.method === 'getAccountContactSummary') {
                publish(target,{traits: payload.response});
            }
        }
    }
]

function mobileCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

export default function subscribeToEvents(portalCode){
    const pushState = window.history.pushState; 
    const replaceState = window.history.replaceState;

    window.history.pushState = function(...args) {
        try{
            if(portalCode === 'QNB'){
                if(args[2] && args[2].indexOf('?') < 0){
                    args[2]+=window.location.search
                }
            }
            pushState.apply(window.history, args);
        }catch(e){
            console.error(e);
        }
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
    };

    //US995071 function to replace state function with null 
    function pruneFunctionsDeep(obj, seen = new WeakSet()) {
        if (obj === null || typeof obj !== 'object') {
            // If primitive or function, return null if function, else as-is
            return (typeof obj === 'function') ? null : obj;
        }
        if (seen.has(obj)) {
            // Avoid circular references
            return null;
        }
        seen.add(obj);

        if (Array.isArray(obj)) {
            return obj.map(item => pruneFunctionsDeep(item, seen));
        }
        const cleanObj = {};

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const val = obj[key];
                cleanObj[key] = (typeof val === 'function') ? null : pruneFunctionsDeep(val, seen);
            }
        }
        return cleanObj;
    }

    window.history.replaceState = function(...args) {
        try{
            if (args[0] !== null && typeof args[0] === 'object') {
                args[0] = pruneFunctionsDeep(args[0]);
            } else if (typeof args[0] === 'function') {
                args[0] = null;
            }

            if(portalCode === 'QNB'){
                if(args[2].indexOf('?') < 0){
                    args[2]+=window.location.search
                }
            }
            replaceState.apply(window.history, args);
        }catch(e){
            console.error(e);
        }
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
    };

    window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('locationchange'))
    });

    let lastLocation;
    window.addEventListener('locationchange', ()=> {
        publish("tracking_pageView", { pathname: window.location.pathname })
        if(lastLocation && lastLocation.startsWith("quote-")){
            MLTagManagerService.sendEventBetweenSteps(lastLocation);
        }
        lastLocation =  window.location.pathname
            .replace("/producer-engage/", "")
            .replace("/quote-and-buy/", "")
            .replace("/account-management/", "");
        
    })

    subscribe([
        JUTRO_TOPICS.VALUE_CHANGED,
        JUTRO_TOPICS.FIELD_BLUR,
        JUTRO_TOPICS.BUTTON_CLICKED,
        JUTRO_TOPICS.LINK_CLICKED
    ], (event) => {
        publish('tracking_fieldInteracted', { elementId: event.id});
        if(event.mlTagManagerLinkClick){
            MLTagManagerService.sendLinkClickEvent(event.mlTagManagerLinkClick)
        }
    });
    subscribe([
        JUTRO_TOPICS.FETCH_RESPONSE
    ], (payload) => {
        payload.path = payload.serviceEndPoint.replace(window.location.origin, "").replace("/", "")
        publish('tracking_serverCall', payload);
    })

    let config;
    if(portalCode === 'GPA'){
        config = peConfig;
    }else if(portalCode === 'AMP'){
        config = ceConfig;
    }else{
        config = qbConfig;
    }

    const allEventNames = _.uniq(config.events.map((entry) => `${entry.category}_${entry.eventName}`));
    const allEvents = {}
    allEventNames.forEach((eventName) => {
        allEvents[eventName] = [];
    })
    config.events.forEach((entry) => {
        const eventName = `${entry.category}_${entry.eventName}`
        allEvents[eventName].push(entry)
    })
    
    allEventNames.forEach((eventName) => {
        const events = allEvents[eventName];
        subscribe(eventName, (payload) => {
            events.forEach((subscribedEvent) => {
                let service;
                if(subscribedEvent.serviceName === "googleAnalytics"){
                    service = GoogleAnalytics
                }else if(subscribedEvent.serviceName === "segmentIO"){
                    service = SegmentIO
                }const event = {
                    category: subscribedEvent.category,
                    eventName: subscribedEvent.eventName
                };
                if (payload) {
                    event.payload = _.cloneDeep(payload);
                    event.payload.channel = mobileCheck() ? 'phone' : 'desktop';
                }
                if(service && service[subscribedEvent.handler]){
                    
                    service[subscribedEvent.handler](event);
                }
                
                transformers.filter((t) => t.source === eventName).forEach((t) => {
                    t.transformer(t.target, payload);
                })
            })
        })
    })
}   